module.exports = __webpack_public_path__ + "img/videowall.03ad7397.webp";